import React, { useRef } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Spinner from './components/Spinner';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import SearchModal from './components/SearchModal';
import CustomCarousel from './components/CustomCarousel';
import About from './components/About';
import Features from './components/Features';
import Gallery from './components/Gallery';
import FactCounter from './components/FactCounter';
import ProjectsSection from './components/ProjectsSection';
import Footer from './components/Footer';
import Amenities from './components/Amenities';
import Location from './components/Location';
import PriceSection from './components/PriceSection';
import SiteAndFloorPlan from './components/SiteAndFloorPlan';

function App() {
  // Refs for sections
  const priceRef = useRef(null);
  const siteandfloorplanRef = useRef(null);
  const amenitiesRef = useRef(null);
  const galleryRef = useRef(null);
  const locationRef = useRef(null);
   const conatctRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Router>
      <Topbar />
      <Navbar
        scrollToSection={scrollToSection}
        refs={{
          priceRef,
          siteandfloorplanRef,
          amenitiesRef,
          galleryRef,
          locationRef,
          conatctRef
        }}
      />
      <SearchModal />

      <Routes>
        <Route
          path="/"
          element={
            <>
              <CustomCarousel />
               <About />
              <div ref={priceRef}>
                <PriceSection/>
              </div>
              <div ref={siteandfloorplanRef}>
                {/* <Features /> */}
                <SiteAndFloorPlan/>
              </div>
              <div ref={amenitiesRef}>
                 <Amenities/>
              </div>
              <FactCounter />
              <div ref={galleryRef}>
               
                 <Gallery />
              </div>
               <div ref={locationRef}>
               <Location/>
              </div>


                {/* <div ref={conatctRef}>
                <ProjectsSection />
              </div> */}
            </>
          }
        />
        {/* Add more routes here if needed */}
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;
